import request from 'superagent';
import _ from 'lodash';
import * as types from '../actionTypes/caseLookupActionTypes';
import courtData from '../../data/courts';


export const partySearch = (query, searchType, searchValue) => function (dispatch) {
  console.log("Requesting Case Lookup", searchType, searchValue, query);
  dispatch({
    type: types.REQUEST_CASE_DATA_OF_CASE_LOOKUP,
    params: query,
  });

  const { court_name, court_code } = query;

  if (!court_code && court_name && court_name.includes(',')) {
    query['court_name[]'] = court_name.split(',');
  }

  if (court_code) {
    delete query.court_code;
    // Replace each court code with its region code
    query['court_code[]'] = court_code
      .split(',')
      .map(code => {
        const court = _.find(courtData, { code });
        if (court) return court.region_code;
        // we were probably passed in region code already
        return code.toLowerCase();
      });
  }

  const onSuccess = response => dispatch({
    type: types.RECEIVE_CASE_DATA_OF_CASE_LOOKUP,
    facets: response.facets,
    contents: response.contents,
    pages: response.pages,
  });

  const onError = response => dispatch({
    type: types.RECEIVE_CASE_LOOKUP_ERROR,
  });

  return request
    .get(`/filings/json/${searchType}/${searchValue}`)
    .query(query)
    .set('Accept', 'application/json')
    .set('Content-Type', 'application/json')
    .then(
      // 200 doesn't mean success, need to check the status flag
      response => response.body.status === 'success' ? onSuccess(response.body) : onError(response),
      onError
    );
};

export const updateFilter = filter => ({
  type: types.UPDATE_FILTERS_OF_CASE_DATA_OF_CASE_LOOKUP,
  filter,
});

export const clearAllFilter = () => ({
  type: types.CLEAR_ALL_FILTERS_OF_CASE_LOOKUP,
});



// WEBPACK FOOTER //
// ./src/redux/actions/caseLookupSearchAction.js